<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div class="flex items-center gap-4 px-5 py-4">
        <button
          class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all text-slate-700"
          (click)="toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button>
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'ข้อมูลผู้จอง' | translate : 'customer-info' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'ระบุรายละเอียดเพื่อยืนยันการจอง' | translate : 'customer-info' }}</p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full px-5 pt-5 pb-32 space-y-4">
      <!-- Profile pre-fill banner -->
      <!-- @if (filledFromProfile()) {
      <div class="flex items-center gap-2.5 rounded-2xl bg-blue-50 border border-blue-100 px-4 py-3">
        <div class="w-7 h-7 rounded-xl bg-blue-100 flex items-center justify-center shrink-0">
          <span class="material-symbols-outlined text-blue-500" style="font-size:1rem">person_check</span>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-xs font-semibold text-blue-700">ดึงข้อมูลจากโปรไฟล์</div>
          <div class="text-[11px] text-blue-400 mt-0.5">กรุณาตรวจสอบและแก้ไขข้อมูลก่อนดำเนินการต่อ</div>
        </div>
      </div>
    } -->

      <!-- Booking Summary -->
      @if (bookingData().branchName) {
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div class="px-4 pt-4 pb-3">
          <div class="flex items-center gap-2 mb-3">
            <div class="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
              <span class="material-symbols-outlined text-blue-500 text-[16px]">hotel</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{ 'สรุปการจอง' | translate : 'customer-info' }}</div>
          </div>
          <!-- Hotel name -->
          <div class="text-sm font-bold text-slate-900">{{bookingData().branchName}}</div>
          @if (bookingData().branchAddress) {
          <div class="mt-0.5 flex items-center gap-1 text-xs text-slate-400">
            <span class="material-symbols-outlined text-[13px] shrink-0">location_on</span>
            <span>{{bookingData().branchAddress}}</span>
          </div>
          }
          <!-- Dates -->
          <div class="mt-3 grid grid-cols-2 gap-2">
            <div class="rounded-xl bg-slate-50 border border-slate-100 px-3 py-2">
              <div class="flex items-center gap-1 mb-0.5">
                <span class="material-symbols-outlined text-green-400 text-[12px]">login</span>
                <span class="text-[10px] text-slate-400">{{ 'เช็คอิน' | translate : 'customer-info' }}</span>
              </div>
              <div class="text-xs font-semibold text-slate-700">{{bookingData().checkIn}}</div>
            </div>
            <div class="rounded-xl bg-slate-50 border border-slate-100 px-3 py-2">
              <div class="flex items-center gap-1 mb-0.5">
                <span class="material-symbols-outlined text-red-400 text-[12px]">logout</span>
                <span class="text-[10px] text-slate-400">{{ 'เช็คเอาท์' | translate : 'customer-info' }}</span>
              </div>
              <div class="text-xs font-semibold text-slate-700">{{bookingData().checkOut}}</div>
            </div>
          </div>
          <!-- Nights + Guests -->
          <div class="mt-2 flex items-center gap-3 flex-wrap">
            <div class="flex items-center gap-1">
              <span class="material-symbols-outlined text-slate-400 text-[14px]">nights_stay</span>
              <span class="text-xs text-slate-500">{{ '{n} คืน' | translate : { module: 'customer-info', n: bookingData().totalNights } }}</span>
            </div>
            <div class="flex items-center gap-1">
              <span class="material-symbols-outlined text-slate-400 text-[14px]">person</span>
              <span class="text-xs text-slate-500">{{ 'ผู้ใหญ่ {count} ท่าน' | translate : { module: 'customer-info', count: bookingData().totalAdults } }}
                @if (bookingData().totalChildren > 0) {· {{ 'เด็ก {count} คน' | translate : { module: 'customer-info', count: bookingData().totalChildren } }}}
              </span>
            </div>
          </div>
          <!-- Selected rooms -->
          @if (bookingData().selectedRooms?.length > 0) {
          <div class="mt-2 pt-2 border-t border-slate-100 space-y-1">
            @for (r of bookingData().selectedRooms; track $index) {
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-1.5 rounded-full bg-blue-300 shrink-0"></span>
                <span class="text-xs text-slate-600 font-medium">{{r.qty}}x {{r.roomName}}</span>
                <span class="text-[11px] text-slate-400">({{r.planName}})</span>
              </div>
              <span class="text-xs font-semibold text-slate-700">{{r.subtotal | number}} {{ 'บาท' | translate : 'customer-info' }}</span>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }

      <!-- Section: ข้อมูลติดต่อ -->
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div class="px-4 pt-4 pb-3">
          <div class="flex items-center gap-2 mb-4">
            <div class="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
              <span class="material-symbols-outlined text-blue-500 text-[16px]">person</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{ 'ข้อมูลติดต่อ' | translate : 'customer-info' }}</div>
          </div>

          <div class="space-y-3">

            <!-- ชื่อผู้จอง -->
            <div>
              <label class="block text-xs font-medium text-slate-500 mb-1.5">
                {{ 'ชื่อ - นามสกุล' | translate : 'customer-info' }}<span class="text-red-400 ml-0.5">*</span>
              </label>
              <div class="relative">
                <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[18px]"
                  [class.text-red-400]="errors['name']" [class.text-slate-400]="!errors['name']">badge</span>
                <input type="text" [placeholder]="'กรอกชื่อ - นามสกุล' | translate : 'customer-info'" [(ngModel)]="form.name"
                  (ngModelChange)="clearError('name')" [class.border-red-300]="errors['name']"
                  [class.border-slate-200]="!errors['name']"
                  class="w-full rounded-xl border bg-slate-50 pl-10 pr-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:bg-white focus:ring-2 outline-none transition-all"
                  [class.focus:border-red-400]="errors['name']" [class.focus:ring-red-500/15]="errors['name']"
                  [class.focus:border-blue-400]="!errors['name']" [class.focus:ring-blue-500/15]="!errors['name']" />
              </div>
              @if (errors['name']) {
              <div class="mt-1 flex items-center gap-1 text-xs text-red-500">
                <span class="material-symbols-outlined text-[13px]">error</span>
                {{ errors['name'] }}
              </div>
              }
            </div>

            <!-- อีเมล -->
            <div>
              <label class="block text-xs font-medium text-slate-500 mb-1.5">
                {{ 'อีเมล' | translate : 'customer-info' }}<span class="text-red-400 ml-0.5">*</span>
              </label>
              <div class="relative">
                <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[18px]"
                  [class.text-red-400]="errors['email']" [class.text-slate-400]="!errors['email']">mail</span>
                <input type="email" [placeholder]="'กรอกอีเมล' | translate : 'customer-info'" [(ngModel)]="form.email"
                  (ngModelChange)="clearError('email')" [class.border-red-300]="errors['email']"
                  [class.border-slate-200]="!errors['email']"
                  class="w-full rounded-xl border bg-slate-50 pl-10 pr-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:bg-white focus:ring-2 outline-none transition-all"
                  [class.focus:border-red-400]="errors['email']" [class.focus:ring-red-500/15]="errors['email']"
                  [class.focus:border-blue-400]="!errors['email']" [class.focus:ring-blue-500/15]="!errors['email']" />
              </div>
              @if (errors['email']) {
              <div class="mt-1 flex items-center gap-1 text-xs text-red-500">
                <span class="material-symbols-outlined text-[13px]">error</span>
                {{ errors['email'] }}
              </div>
              }
            </div>

            <!-- ประเทศ -->
            <div>
              <label class="block text-xs font-medium text-slate-500 mb-1.5">
                {{ 'ประเทศ' | translate : 'customer-info' }}<span class="text-red-400 ml-0.5">*</span>
              </label>

              <!-- Trigger button -->
              <button type="button" (click)="showCountryDropdown.set(true)"
                class="w-full flex items-center gap-2.5 rounded-xl border bg-slate-50 px-3 py-2.5 text-sm text-left transition-all focus:outline-none"
                [class.border-red-300]="errors['phoneCode']" [class.border-slate-200]="!errors['phoneCode']">
                @if (countriesLoading()) {
                <span class="material-symbols-outlined text-slate-400 text-[18px] animate-spin">progress_activity</span>
                <span class="text-slate-400 flex-1">{{ 'กำลังโหลด...' | translate : 'customer-info' }}</span>
                } @else if (selectedCountryOption()) {
                <span
                  class="inline-flex items-center rounded-md bg-blue-50 border border-blue-100 px-2 py-0.5 text-xs font-mono font-semibold text-blue-700 shrink-0">
                  {{selectedCountryOption()!.phone}}
                </span>
                <span class="flex-1 text-slate-800 truncate">{{selectedCountryOption()!.name}}</span>
                } @else {
                <span class="material-symbols-outlined text-slate-400 text-[18px]">public</span>
                <span class="flex-1 text-slate-400">{{ 'เลือกประเทศ' | translate : 'customer-info' }}</span>
                }
                <span class="material-symbols-outlined text-slate-400 text-[18px] shrink-0">expand_more</span>
              </button>

              @if (errors['phoneCode']) {
              <div class="mt-1 flex items-center gap-1 text-xs text-red-500">
                <span class="material-symbols-outlined text-[13px]">error</span>
                {{ errors['phoneCode'] }}
              </div>
              }
            </div>

            <!-- เบอร์โทร -->
            <div class="pb-1">
              <label class="block text-xs font-medium text-slate-500 mb-1.5">
                {{ 'เบอร์โทรศัพท์' | translate : 'customer-info' }}<span class="text-red-400 ml-0.5">*</span>
              </label>
              <div class="relative">
                <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[18px]"
                  [class.text-red-400]="errors['phone']" [class.text-slate-400]="!errors['phone']">call</span>
                <input type="tel" [placeholder]="'กรอกเบอร์โทรศัพท์' | translate : 'customer-info'" [(ngModel)]="form.phone"
                  (ngModelChange)="clearError('phone')" [class.border-red-300]="errors['phone']"
                  [class.border-slate-200]="!errors['phone']"
                  class="w-full rounded-xl border bg-slate-50 pl-10 pr-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:bg-white focus:ring-2 outline-none transition-all"
                  [class.focus:border-red-400]="errors['phone']" [class.focus:ring-red-500/15]="errors['phone']"
                  [class.focus:border-blue-400]="!errors['phone']" [class.focus:ring-blue-500/15]="!errors['phone']" />
              </div>
              @if (errors['phone']) {
              <div class="mt-1 flex items-center gap-1 text-xs text-red-500">
                <span class="material-symbols-outlined text-[13px]">error</span>
                {{ errors['phone'] }}
              </div>
              }
            </div>

          </div>
        </div>
      </div>

      <!-- Section: ผู้เข้าพัก -->
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div class="px-4 pt-4 pb-4">
          <div class="flex items-center gap-2 mb-3">
            <div class="w-7 h-7 rounded-lg bg-violet-50 flex items-center justify-center shrink-0">
              <span class="material-symbols-outlined text-violet-500 text-[16px]">hotel</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{ 'ผู้เข้าพัก' | translate : 'customer-info' }}</div>
          </div>

          <!-- Checkbox -->
          <label for="notMainGuest" class="flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-colors"
            [class.bg-blue-50]="form.notMainGuest" [class.border-blue-200]="form.notMainGuest"
            [class.bg-slate-50]="!form.notMainGuest" [class.border-slate-200]="!form.notMainGuest"
            style="border-width:1px; border-style:solid;">
            <input type="checkbox" id="notMainGuest" [(ngModel)]="form.notMainGuest"
              class="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer shrink-0" />
            <div>
              <div class="text-sm font-medium text-slate-700">{{ 'ฉันไม่ใช่ผู้เข้าพักหลัก' | translate : 'customer-info' }}</div>
              <div class="text-xs text-slate-400 mt-0.5">{{ 'ระบุชื่อผู้เข้าพักจริงในกรณีจองแทน' | translate : 'customer-info' }}</div>
            </div>
          </label>

          <!-- ชื่อผู้เข้าพักหลัก -->
          @if (form.notMainGuest) {
          <div class="mt-3">
            <label class="block text-xs font-medium text-slate-500 mb-1.5">
              {{ 'ชื่อผู้เข้าพักหลัก' | translate : 'customer-info' }}<span class="text-red-400 ml-0.5">*</span>
            </label>
            <div class="relative">
              <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[18px]"
                [class.text-red-400]="errors['mainGuestName']"
                [class.text-slate-400]="!errors['mainGuestName']">person</span>
              <input type="text" [placeholder]="'ระบุชื่อผู้เข้าพักหลัก' | translate : 'customer-info'" [(ngModel)]="form.mainGuestName"
                (ngModelChange)="clearError('mainGuestName')" [class.border-red-300]="errors['mainGuestName']"
                [class.border-slate-200]="!errors['mainGuestName']"
                class="w-full rounded-xl border bg-slate-50 pl-10 pr-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:bg-white focus:ring-2 outline-none transition-all"
                [class.focus:border-red-400]="errors['mainGuestName']"
                [class.focus:ring-red-500/15]="errors['mainGuestName']"
                [class.focus:border-blue-400]="!errors['mainGuestName']"
                [class.focus:ring-blue-500/15]="!errors['mainGuestName']" />
            </div>
            @if (errors['mainGuestName']) {
            <div class="mt-1 flex items-center gap-1 text-xs text-red-500">
              <span class="material-symbols-outlined text-[13px]">error</span>
              {{ errors['mainGuestName'] }}
            </div>
            }
          </div>
          }
        </div>
      </div>

      <!-- Notice -->
      <div class="rounded-2xl bg-amber-50 border border-amber-100 px-4 py-3">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-amber-400 text-[18px] shrink-0 mt-0.5">info</span>
          <div class="text-xs leading-5 text-amber-700">
            {{ 'ข้อมูลของท่านจะถูกใช้สำหรับการยืนยันการจองเท่านั้น' | translate : 'customer-info' }}
          </div>
        </div>
      </div>

    </div>
    <br>

    <!-- Bottom Bar -->
    <div
      class="absolute bottom-0 inset-x-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-20 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
            <span class="material-symbols-outlined text-blue-500 text-[16px]">hotel</span>
          </div>
          <div>
            <div class="text-[11px] text-slate-400 font-medium">{{ 'ห้องพัก {count} ห้อง' | translate : { module: 'customer-info', count: bookingData().totalRooms } }}</div>
            <div class="text-sm font-bold text-slate-800">{{ '{n} คืน' | translate : { module: 'customer-info', n: bookingData().totalNights } }}</div>
          </div>
        </div>
        <div class="text-right">
          <div class="text-[11px] text-slate-400 font-medium uppercase tracking-wider mb-0.5">{{ 'ยอดชำระ' | translate : 'customer-info' }}</div>
          <div class="text-lg font-black text-slate-900 leading-none">{{bookingData().totalPrice | number}} <span
              class="text-xs font-bold text-slate-500">{{ 'บาท' | translate : 'customer-info' }}</span></div>
        </div>
      </div>
      <button
        class="w-full rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 py-3.5 text-sm font-bold text-white hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98] transition-all shadow-md shadow-blue-300"
        (click)="toNextStep()">
        {{ 'ดำเนินการต่อ' | translate : 'customer-info' }}
      </button>
    </div>

  </div>
</div>

<!-- ── Country Bottom Sheet ── -->
@if (showCountryDropdown()) {
<!-- Backdrop -->
<div class="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm"
  (click)="showCountryDropdown.set(false); countrySearch.set('')">
</div>

<!-- Sheet -->
<div class="fixed bottom-0 left-0 right-0 z-50 flex flex-col bg-white rounded-t-2xl shadow-2xl"
  style="max-height: 75dvh">

  <!-- Handle bar -->
  <div class="flex justify-center pt-3 pb-1 shrink-0">
    <div class="w-10 h-1 rounded-full bg-slate-300"></div>
  </div>

  <!-- Sheet header -->
  <div class="flex items-center justify-between px-4 py-3 shrink-0 border-b border-slate-100">
    <div>
      <p class="text-sm font-semibold text-slate-800">{{ 'เลือกประเทศ' | translate : 'customer-info' }}</p>
      <p class="text-xs text-slate-400 mt-0.5">{{ '{count} รายการ' | translate : { module: 'customer-info', count: filteredCountryOptions().length } }}</p>
    </div>
    <button type="button" (click)="showCountryDropdown.set(false); countrySearch.set('')"
      class="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors">
      <span class="material-symbols-outlined text-slate-500" style="font-size:1rem">close</span>
    </button>
  </div>

  <!-- Search -->
  <div class="px-4 py-3 shrink-0">
    <div class="relative">
      <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
        style="font-size:1rem">search</span>
      <input type="text" [placeholder]="'ค้นหาชื่อประเทศหรือรหัส...' | translate : 'customer-info'" [ngModel]="countrySearch()"
        (ngModelChange)="countrySearch.set($event)"
        class="w-full rounded-xl border border-slate-200 bg-slate-50 pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/15 focus:bg-white transition-all" />
    </div>
  </div>

  <!-- Country list -->
  <div class="flex-1 overflow-y-auto divide-y divide-slate-100">
    @if (filteredCountryOptions().length === 0) {
    <div class="px-4 py-10 text-center text-sm text-slate-400">
      {{ 'ไม่พบประเทศที่ค้นหา' | translate : 'customer-info' }}
    </div>
    }
    @for (opt of filteredCountryOptions(); track opt.code) {
    <button type="button" class="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors"
      [class.bg-blue-50]="opt.code === form.phoneCode" [class.hover:bg-blue-50]="opt.code === form.phoneCode"
      [class.hover:bg-slate-50]="opt.code !== form.phoneCode" (click)="selectCountry(opt)">
      <span
        class="inline-flex items-center justify-center rounded-lg px-2 py-1 text-xs font-mono font-semibold shrink-0 min-w-[56px]"
        [class.bg-blue-100]="opt.code === form.phoneCode" [class.text-blue-700]="opt.code === form.phoneCode"
        [class.bg-slate-100]="opt.code !== form.phoneCode" [class.text-slate-600]="opt.code !== form.phoneCode">
        {{opt.phone}}
      </span>
      <span class="flex-1 text-sm truncate" [class.font-semibold]="opt.code === form.phoneCode"
        [class.text-blue-700]="opt.code === form.phoneCode" [class.text-slate-700]="opt.code !== form.phoneCode">
        {{opt.name}}
      </span>
      @if (opt.code === form.phoneCode) {
      <span class="material-symbols-outlined text-blue-600 shrink-0" style="font-size:1.1rem">check_circle</span>
      }
    </button>
    }
  </div>

</div>
}